"use client";

import {
  BasicTextStyleButton,
  BlockTypeSelect,
  CreateLinkButton,
  FileCaptionButton,
  FileDeleteButton,
  FileRenameButton,
  FileReplaceButton,
  FileDownloadButton,
  FilePreviewButton,
  FormattingToolbar,
  NestBlockButton,
  UnnestBlockButton,
  TableCellMergeButton,
} from "@blocknote/react";
import { TextAlignButtonWithVA } from "./TextAlignButtonWithVA";
import { VerticalAlignButton } from "./VerticalAlignButton";
import { TableAlignButton } from "./TableAlignButton";
import { FontSizeButton } from "./FontSizeButton";
import {
  LumirColorStyleButton,
  LumirCellColorToolbarButton,
} from "./color/LumirColorControls";

/**
 * BlockNote 기본 FormattingToolbar + 세로 정렬 버튼(top/middle/bottom)
 *
 * @see https://www.blocknotejs.org/examples/ui-components/formatting-toolbar-buttons
 */
export const CustomFormattingToolbar = () => {
  return (
    <FormattingToolbar>
      <BlockTypeSelect key={"blockTypeSelect"} />
      <TableCellMergeButton key={"tableCellMergeButton"} />

      <FileCaptionButton key={"fileCaptionButton"} />
      <FileReplaceButton key={"replaceFileButton"} />
      <FileRenameButton key={"fileRenameButton"} />
      <FileDeleteButton key={"fileDeleteButton"} />
      <FileDownloadButton key={"fileDownloadButton"} />
      <FilePreviewButton key={"filePreviewButton"} />

      <BasicTextStyleButton basicTextStyle={"bold"} key={"boldStyleButton"} />
      <BasicTextStyleButton
        basicTextStyle={"italic"}
        key={"italicStyleButton"}
      />
      <BasicTextStyleButton
        basicTextStyle={"underline"}
        key={"underlineStyleButton"}
      />
      <BasicTextStyleButton
        basicTextStyle={"strike"}
        key={"strikeStyleButton"}
      />

      <TextAlignButtonWithVA textAlignment={"left"} key={"textAlignLeftButton"} />
      <TextAlignButtonWithVA
        textAlignment={"center"}
        key={"textAlignCenterButton"}
      />
      <TextAlignButtonWithVA textAlignment={"right"} key={"textAlignRightButton"} />

      {/* 세로 정렬 버튼 (테이블 셀 선택 시에만 표시) */}
      <VerticalAlignButton
        verticalAlignment="top"
        key={"verticalAlignTop"}
      />
      <VerticalAlignButton
        verticalAlignment="middle"
        key={"verticalAlignMiddle"}
      />
      <VerticalAlignButton
        verticalAlignment="bottom"
        key={"verticalAlignBottom"}
      />

      {/* 표 블록 정렬 버튼 (표 컨텍스트에서만 표시) */}
      <TableAlignButton alignment="left" key={"tableAlignLeft"} />
      <TableAlignButton alignment="center" key={"tableAlignCenter"} />
      <TableAlignButton alignment="right" key={"tableAlignRight"} />

      <FontSizeButton key={"fontSizeButton"} />
      <LumirColorStyleButton key={"colorStyleButton"} />
      <LumirCellColorToolbarButton key={"cellColorButton"} />
      <NestBlockButton key={"nestBlockButton"} />
      <UnnestBlockButton key={"unnestBlockButton"} />
      <CreateLinkButton key={"createLinkButton"} />
    </FormattingToolbar>
  );
};
